<script setup lang="ts">
import { PhIdentificationCard as IdentificationCard } from "@phosphor-icons/vue";
import type { WorkhorseIdentity } from "../types";

defineProps<{
  identity: WorkhorseIdentity;
}>();
</script>

<template>
  <section class="workhorse-id-card" aria-labelledby="workhorse-id-title">
    <header class="workhorse-id-card__header">
      <span><IdentificationCard :size="22" weight="fill" /></span>
      <div>
        <h2 id="workhorse-id-title">牛马体质身份证</h2>
      </div>
      <b>{{ identity.employeeId }}</b>
    </header>

    <dl class="workhorse-id-card__body">
      <div>
        <dt>核心成分</dt>
        <dd>{{ identity.ingredients }}</dd>
      </div>
      <div>
        <dt>性格标签</dt>
        <dd class="workhorse-id-card__tags">
          <span v-for="tag in identity.tags" :key="tag">{{ tag }}</span>
        </dd>
      </div>
      <div class="workhorse-id-card__slogan">
        <dt>牛马 slogan</dt>
        <dd>{{ identity.slogan }}</dd>
      </div>
    </dl>
  </section>
</template>
